import { Helmet } from 'react-helmet-async';

/**
 * Reusable SEO component — sets per-page title, description,
 * and Open Graph tags. Canonical + og:url are set globally by HeadSync.
 *
 * All URLs are absolute (production domain) so LinkedIn/Twitter
 * previews resolve correctly.
 */

const SITE_URL = 'https://gate33.co';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;

const SEO = ({
  title,
  description,
  image = DEFAULT_OG_IMAGE,
  type = 'website',
  keywords,
  jsonLd,
  noindex = false,
}) => {
  const fullTitle = title
    ? (title.includes('| Gate 33') ? title : `${title} | Gate 33`)
    : 'Gate 33 | Private Aviation Training & Consulting';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Gate 33" />
      <meta property="og:locale" content="en_GB" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* JSON-LD structured data */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
